module.exports = __webpack_public_path__ + "img/luthi-6.5f0dac7f.jpg";